module.exports = __webpack_public_path__ + "static/google-cloud-functions-1075bce56257f3cdfd10bcb8b4aeb61f.svg";